module.exports = __webpack_public_path__ + "img/gh_f5a763c5a7d1.7efbcda1.jpg";